<template>
  <section :class="$style.recent">
    <h2 :class="[$style.title, 'h3']">{{ t('blog.recent') }}</h2>

    <div :class="$style.list">
      <transition-group name="fade">
        <BlogSinglePostSkeleton
          v-show="loading !== 'success'"
          v-for="i of 3"
        />
      </transition-group>
      <transition-group name="fade">
        <BlogSinglePost
          v-show="loading === 'success'"
          v-for="(post, index) of posts"
          :key="index"
          :title="post.title.rendered"
          :image="post.featured_image_url || '/images/topPost.webp'"
          :date="post.date"
          :caption="post.excerpt.rendered"
          :_id="post.id"
        />
      </transition-group>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { RepcentPostsParams } from '@/components/Blog/index.js';

const { t } = useI18n();
defineProps<RepcentPostsParams>();
</script>

<style lang="scss" module>
  .recent {

  }

  .title {
    margin: 0 0 32px 0;
  }

  .list {
    display: flex;
    gap: 32px 24px;

    @media (max-width: 1023px) {
      gap: 18px;

      > *:last-child {
        display: none;
      }
    }

    @media (max-width: 767px) {
      gap: 22px;
      flex-wrap: wrap;
      flex-direction: column;
    }

    > * {
      flex: 1;

      @media (min-width: 768px) {
        max-width: calc(100% / 3 - 22px);
      }
    }
  }
</style>